module.exports = __webpack_public_path__ + "static/assets/a0ebff6479ca983b400014a356c746d1.png";